export const tools_cadastro_os = [
    {
        type: "function",
        function: {
            name: "createNewServiceOrder",
            description: "Creates a new budget ou service order for a customer. IMPORTANT!: Do not check existence the customer(client)",
            parameters: {
                type: "object",
                properties: {
                    data: {
                        type: "object",
                        properties: {
                            client: {
                                type: "string",
                                description: "Customer Name, Company Name, CPF or CNPJ (CPF/CNPJ takes priority). CPF must have 11 digits, CNPJ 14. Extract digits only, without spaces or special characters"
                            },
                            plate: {
                                type: "string",
                                minLength: 7,
                                maxLength: 7,
                                pattern: "^[A-Z]{3}[0-9]{4}$|^[A-Z]{3}[0-9][A-Z][0-9]{2}$",
                                description: "Vehicle license plate. Return without special characters or spaces (required)"
                            },
                            isBudget: {
                                type: "boolean",
                                default: false,
                                description: "This is only true if the user says 'budget' (Portuguese: 'orçamento'). If the user's intent is unclear, to set this to 'false'."
                            },
                            tipo_os: {
                                type: ["string", "null"],
                                enum: ['default'],
                                description: "Type of service order ou budget, if provided by the user. DO NOT ask for this if the user does not mention it."
                            },
                            tipo_operation: {
                                type: ["string", "null"],
                                enum: ['default'],
                                description: "Type of operation, if provided by the user. DO NOT ask for this if the user does not mention it."
                            },
                            prisma: {
                                type: ["string", "null"],
                                description: "Prism code, if provided by the user. DO NOT ask for this if the user does not mention it."
                            },
                            report: {
                                type: ["string", "null"],
                                description: "The customer's account of the problem or required service, if provided by the user. DO NOT ask for this if the user does not mention it."
                            }
                        },
                        required: ["client", "plate", "isBudget"]
                    },
                },
                required: ["data"],
                additionalProperties: false

            },
        },
    }
];
